var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9099 11.7251C20.9099 16.6151 17.3599 21.1951 12.5099 22.5351C12.1799 22.6251 11.8198 22.6251 11.4898 22.5351C6.63984 21.1951 3.08984 16.6151 3.08984 11.7251V7.33508C3.08984 6.51508 3.70986 5.58508 4.47986 5.27508L10.0498 2.99511C11.2998 2.48511 12.7098 2.48511 13.9598 2.99511L19.5298 5.27508C20.2898 5.58508 20.9199 6.51508 20.9199 7.33508L20.9099 11.7251Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.d65479bd7aa1edf68627501b963355a5.svg";
export { ForwardRef as ReactComponent };